import React from 'react';
import styles from './post-section.css';

export const PostSection = (props) => {
  return(
    <section className="postsection" styles={styles}>
      {props.title && 
      <header className="postsection__header">
        <h1 className="postsection__header__title" dangerouslySetInnerHTML={{__html:props.title}}/>
      </header>
      }
      <div className="postsection__content">
        <div className="postsection__content__background"/>
        <div className="postsection__content__container">
          {props.children}
        </div>
      </div>
    </section>
  )
}
